import React from 'react';
import { Box, Typography } from '@mui/material';
import { Phone as PhoneIcon } from '@mui/icons-material';

interface VisitorInfoProps {
  name: string;
  phone: string;
  variant?: 'compact' | 'normal' | 'full';
}

const VisitorInfo: React.FC<VisitorInfoProps> = ({ name, phone, variant = 'normal' }) => {
  if (variant === 'compact') {
    return (
      <Box sx={{ flex: '1 1 100px', minWidth: 0 }}>
        <Typography variant="subtitle2" fontWeight={600} noWrap sx={{ lineHeight: 1.2, mb: 0.25 }}>
          {name}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          display="block"
          noWrap
          sx={{ lineHeight: 1.2 }}
        >
          <PhoneIcon sx={{ fontSize: 11, verticalAlign: 'middle', mr: 0.3 }} />
          {phone}
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="subtitle1" fontWeight={600} noWrap>
        {name}
      </Typography>
      <Typography variant="body2" color="text.secondary" noWrap>
        <PhoneIcon sx={{ fontSize: 13, verticalAlign: 'middle', mr: 0.5 }} />
        {phone}
      </Typography>
    </Box>
  );
};

export default VisitorInfo;
